/* Vrtex theme JS: bundle builder, cart drawer, header count. No dependencies. */
(function () {
  'use strict';

  var V = window.Vrtex || {};
  var routes = V.routes || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };
  var UNIT = V.unitName || 'spinner';
  var FREE_SHIP_QTY = parseInt(V.freeShipQty, 10) || 0;

  /* ---------- helpers ---------- */

  function formatMoney(cents, format) {
    format = format || V.moneyFormat || '${{amount}}';
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholderRegex);
    var type = match ? match[1] : 'amount';

    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    switch (type) {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(placeholderRegex, value);
  }

  function plural(n, word) { return n + ' ' + word + (n === 1 ? '' : 's'); }

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Bundle price for n items: floor(n/3) three-packs + remainder at the 1 or 2 price. */
  function dealPrice(n, unit, price2, price3) {
    var packs = Math.floor(n / 3), rem = n % 3;
    var remPrice = rem === 1 ? unit : rem === 2 ? price2 : 0;
    return packs * price3 + remPrice;
  }

  /* What adding one more spinner does to the price, phrased for the tier the shopper is in. */
  function nudgeText(n, price2, price3) {
    if (!n) return '';
    var unitPrice = V.unitPrice || 0;
    var rem = n % 3;
    if (rem === 0) return '';
    var next = n + 1;
    var marginal = dealPrice(next, unitPrice, price2, price3) - dealPrice(n, unitPrice, price2, price3);
    var packs = Math.floor(n / 3);
    var ship = FREE_SHIP_QTY > 0 && n < FREE_SHIP_QTY && next >= FREE_SHIP_QTY ? ' and free shipping' : '';
    var just = marginal > 0 && marginal < unitPrice ? ' for just <strong>' + formatMoney(marginal) + '</strong>' : '';
    var nextTotal = formatMoney(dealPrice(next, unitPrice, price2, price3));

    if (rem === 1) {
      if (packs === 0) return 'Add <strong>1 more</strong>' + just + ' and pay <strong>' + formatMoney(price2) + '</strong> for two' + ship + '.';
      return 'Add <strong>1 more</strong>' + just + ' and the extras become a 2-pack: <strong>' + next + ' for ' + nextTotal + '</strong>' + ship + '.';
    }
    // rem === 2
    if (packs === 0) return 'Add <strong>1 more</strong>' + just + ' to unlock the 3-pack: <strong>3 for ' + formatMoney(price3) + '</strong>' + ship + '.';
    var which = packs === 1 ? 'a second' : 'another';
    return 'Add <strong>1 more</strong>' + just + ' to complete ' + which + ' 3-pack: <strong>' + next + ' for ' + nextTotal + '</strong>' + ship + '.';
  }

  function fetchJSON(url, opts) {
    opts = opts || {};
    opts.headers = Object.assign({ 'Content-Type': 'application/json', 'Accept': 'application/json' }, opts.headers || {});
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw data;
        return data;
      });
    });
  }

  var toastEl;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'toast'; document.body.appendChild(toastEl); }
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2800);
  }

  /* ---------- cart drawer ---------- */

  var drawer = document.querySelector('[data-cart-drawer]');
  var drawerBody = drawer && drawer.querySelector('[data-cart-body]');
  var drawerFoot = drawer && drawer.querySelector('[data-cart-foot]');
  var lastFocus = null;
  var cartState = null;          // last cart we rendered (server or optimistic)
  var pending = {};              // line key -> timer
  var seq = 0;                   // request sequence, so stale responses are ignored

  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var close = drawer.querySelector('[data-cart-close]');
    if (close) close.focus();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function lineHTML(item) {
    var img = item.image
      ? '<img src="' + escapeHtml(item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=160') + '" alt="" loading="lazy">'
      : '<img class="cart-line__emblem" src="' + escapeHtml(V.emblem || '') + '" alt="">';
    var variant = item.variant_title && item.variant_title !== 'Default Title'
      ? '<div class="cart-line__variant">' + escapeHtml(item.variant_title) + '</div>' : '';
    var price = item.final_line_price < item.original_line_price
      ? '<s>' + formatMoney(item.original_line_price) + '</s>' + formatMoney(item.final_line_price)
      : formatMoney(item.final_line_price);
    return '' +
      '<div class="cart-line' + (item._syncing ? ' is-syncing' : '') + '" data-line-key="' + escapeHtml(item.key) + '">' +
        '<div class="cart-line__img">' + img + '</div>' +
        '<div>' +
          '<div class="cart-line__title">' + escapeHtml(item.product_title) + '</div>' + variant +
          '<div class="cart-line__row">' +
            '<div class="stepper">' +
              '<button type="button" data-line-dec aria-label="Remove one">&minus;</button>' +
              '<output>' + item.quantity + '</output>' +
              '<button type="button" data-line-inc aria-label="Add one">+</button>' +
            '</div>' +
            '<button type="button" class="cart-line__remove" data-line-remove>Remove</button>' +
          '</div>' +
        '</div>' +
        '<div class="cart-line__price" data-line-price>' + price + '</div>' +
      '</div>';
  }

  function renderCart(cart) {
    cartState = cart;
    if (cart.items && cart.items.length && cart.items[0].original_price) V.unitPrice = cart.items[0].original_price;
    setCount(cart.item_count);
    if (!drawerBody || !drawerFoot) return;

    if (!cart.items.length) {
      drawerBody.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is empty.</p><a class="btn btn--ghost" href="' + routes.root + '#shop">Pick your ' + UNIT + 's</a></div>';
      drawerFoot.hidden = true;
      return;
    }

    drawerBody.innerHTML = cart.items.map(lineHTML).join('');
    drawerFoot.hidden = false;

    var totals = drawerFoot.querySelector('[data-cart-totals]');
    var html = '';
    html += '<div class="cart-totals__row"><span>' + plural(cart.item_count, UNIT) + '</span><span>' + formatMoney(cart.original_total_price) + '</span></div>';
    if (cart.total_discount > 0) {
      html += '<div class="cart-totals__row cart-totals__row--save"><span>Bundle deal</span><span>&minus;' + formatMoney(cart.total_discount) + '</span></div>';
    }
    if (FREE_SHIP_QTY > 0 && cart.item_count >= FREE_SHIP_QTY) {
      html += '<div class="cart-totals__row cart-totals__row--save"><span>Shipping</span><span>Free</span></div>';
    }
    html += '<div class="cart-totals__row cart-totals__row--total"><span>Total</span><span>' + formatMoney(cart.total_price) + '</span></div>';
    totals.innerHTML = html;

    var nudge = drawerFoot.querySelector('[data-cart-nudge]');
    if (nudge) {
      var text = nudgeText(cart.item_count, V.price2, V.price3);
      nudge.innerHTML = text ? '<p class="cart-nudge">' + text + '</p>' : '';
    }
  }

  /* Rebuild totals locally so the drawer answers a click before the server does. */
  function optimisticCart(cart) {
    var items = cart.items.filter(function (i) { return i.quantity > 0; });
    var count = 0, original = 0;
    items.forEach(function (i) {
      i.original_line_price = i.original_price * i.quantity;
      i.final_line_price = i.original_line_price;
      count += i.quantity;
      original += i.original_line_price;
    });
    var expected = dealPrice(count, items.length ? items[0].original_price : 0, V.price2, V.price3);
    var discount = Math.max(0, original - expected);
    return {
      items: items,
      item_count: count,
      original_total_price: original,
      total_discount: discount,
      total_price: original - discount
    };
  }

  function refreshCart(open) {
    var mySeq = ++seq;
    return fetchJSON(routes.cart + '.js').then(function (cart) {
      if (mySeq !== seq) return cart;
      renderCart(cart);
      if (open) openDrawer();
      return cart;
    });
  }

  function setLineQuantity(key, quantity) {
    if (!cartState) return;
    // 1. update the local copy and repaint immediately
    var next = { items: cartState.items.map(function (i) { return Object.assign({}, i); }) };
    next.items.forEach(function (i) { if (i.key === key) { i.quantity = quantity; i._syncing = true; } });
    renderCart(optimisticCart(next));

    // 2. send the latest quantity for this line after a short pause, so fast taps become one request
    clearTimeout(pending[key]);
    pending[key] = setTimeout(function () {
      var mySeq = ++seq;
      fetchJSON(routes.cartChange + '.js', { method: 'POST', body: JSON.stringify({ id: key, quantity: quantity }) })
        .then(function (cart) { if (mySeq === seq) renderCart(cart); })
        .catch(function (err) {
          toast((err && err.description) || 'Could not update cart.');
          refreshCart(false);
        });
    }, 180);
  }

  if (drawer) {
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-close]') || e.target.matches('[data-cart-overlay]')) { closeDrawer(); return; }
      var line = e.target.closest('[data-line-key]');
      if (!line || !cartState) return;
      var key = line.getAttribute('data-line-key');
      var item = cartState.items.filter(function (i) { return i.key === key; })[0];
      if (!item) return;
      if (e.target.closest('[data-line-inc]')) setLineQuantity(key, item.quantity + 1);
      else if (e.target.closest('[data-line-dec]')) setLineQuantity(key, Math.max(0, item.quantity - 1));
      else if (e.target.closest('[data-line-remove]')) setLineQuantity(key, 0);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-cart-open]');
    if (!trigger) return;
    e.preventDefault();
    if (cartState) openDrawer();
    refreshCart(!cartState);
  });

  // Keep the header count honest when the page comes back from the browser cache.
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(false); });

  /* ---------- bundle builder ---------- */

  function initShop(root) {
    if (root._vrtexInit) return;
    root._vrtexInit = true;

    var dataEl = root.querySelector('[data-shop-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }
    if (!variants.length) return;

    var price2 = parseInt(root.getAttribute('data-price-2'), 10) || V.price2 || 0;
    var price3 = parseInt(root.getAttribute('data-price-3'), 10) || V.price3 || 0;
    var unitPrice = variants[0].price;
    if (!V.unitPrice) V.unitPrice = unitPrice;

    var image = root.querySelector('[data-shop-image]');
    var placeholder = root.querySelector('[data-shop-placeholder]');
    var placeholderLabel = root.querySelector('[data-shop-placeholder-label]');
    var currentName = root.querySelector('[data-shop-current-name]');
    var dots = root.querySelector('[data-shop-dots]');
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-row]'));
    var tiers = Array.prototype.slice.call(root.querySelectorAll('[data-tier]'));
    var sumCount = root.querySelector('[data-summary-count]');
    var sumCompare = root.querySelector('[data-summary-compare]');
    var sumTotal = root.querySelector('[data-summary-total]');
    var sumSave = root.querySelector('[data-summary-save]');
    var sumShip = root.querySelector('[data-summary-ship]');
    var sumNudge = root.querySelector('[data-summary-nudge]');
    var summary = root.querySelector('[data-summary]');
    var addBtn = root.querySelector('[data-add]');
    var addLabel = root.querySelector('[data-add-label]');

    var qty = {};
    variants.forEach(function (v) { qty[v.id] = 0; });

    var current = 0;
    for (var i = 0; i < variants.length; i++) { if (variants[i].available) { current = i; break; } }

    if (dots) {
      dots.innerHTML = variants.map(function (v, idx) {
        return '<button type="button" class="shop__dot" data-dot="' + idx + '" aria-label="Show ' + escapeHtml(v.title) + '"></button>';
      }).join('');
    }

    function show(idx) {
      current = (idx + variants.length) % variants.length;
      var v = variants[current];
      if (v.image && image) {
        image.src = v.image;
        image.alt = v.title;
        image.hidden = false;
        if (placeholder) placeholder.hidden = true;
      } else {
        if (image) image.hidden = true;
        if (placeholder) placeholder.hidden = false;
        if (placeholderLabel) placeholderLabel.textContent = v.title;
      }
      if (currentName) currentName.textContent = v.title;
      rows.forEach(function (r, i) { r.classList.toggle('is-current', i === current); });
      if (dots) {
        Array.prototype.forEach.call(dots.children, function (d, i) { d.classList.toggle('is-active', i === current); });
      }
    }

    function totalQty() {
      return Object.keys(qty).reduce(function (s, k) { return s + qty[k]; }, 0);
    }

    function update() {
      var n = totalQty();
      var compare = 0;
      variants.forEach(function (v) { compare += qty[v.id] * v.price; });
      var total = dealPrice(n, unitPrice, price2, price3);
      var save = Math.max(0, compare - total);

      rows.forEach(function (r) {
        var id = r.getAttribute('data-variant-id');
        var out = r.querySelector('[data-qty]');
        var v = variants.filter(function (x) { return String(x.id) === id; })[0];
        out.textContent = qty[id];
        r.classList.toggle('has-qty', qty[id] > 0);
        r.querySelector('[data-dec]').disabled = qty[id] === 0;
        r.querySelector('[data-inc]').disabled = !v.available || qty[id] >= v.max;
      });

      var activeTier = Math.min(n, 3);
      if (summary) summary.classList.toggle('is-sticky', n > 0);
      tiers.forEach(function (t) { t.classList.toggle('is-active', parseInt(t.getAttribute('data-tier'), 10) === activeTier); });

      if (n === 0) {
        sumCount.textContent = 'No ' + UNIT + 's selected';
        sumTotal.textContent = formatMoney(0);
        sumCompare.hidden = true;
        sumSave.hidden = true;
        if (sumShip) sumShip.hidden = true;
        if (sumNudge) sumNudge.hidden = true;
        addBtn.disabled = true;
        addLabel.textContent = 'Add to cart';
      } else {
        sumCount.textContent = plural(n, UNIT);
        sumTotal.textContent = formatMoney(total);
        if (save > 0) {
          sumCompare.textContent = formatMoney(compare);
          sumCompare.hidden = false;
          sumSave.textContent = 'You save ' + formatMoney(save);
          sumSave.hidden = false;
        } else {
          sumCompare.hidden = true;
          sumSave.hidden = true;
        }
        if (sumShip) sumShip.hidden = !(FREE_SHIP_QTY > 0 && n >= FREE_SHIP_QTY);
        if (sumNudge) {
          var text = nudgeText(n, price2, price3);
          sumNudge.innerHTML = text;
          sumNudge.hidden = !text;
        }
        addBtn.disabled = false;
        addLabel.textContent = 'Add ' + plural(n, UNIT) + ' to cart';
      }
    }

    root.addEventListener('click', function (e) {
      var dot = e.target.closest('[data-dot]');
      if (dot) { show(parseInt(dot.getAttribute('data-dot'), 10)); return; }
      if (e.target.closest('[data-shop-prev]')) { show(current - 1); return; }
      if (e.target.closest('[data-shop-next]')) { show(current + 1); return; }

      var row = e.target.closest('[data-row]');
      if (!row) return;
      var id = row.getAttribute('data-variant-id');
      var idx = rows.indexOf(row);
      var v = variants[idx];

      if (e.target.closest('[data-inc]')) {
        if (v.available && qty[id] < v.max) qty[id] += 1;
        show(idx); update(); return;
      }
      if (e.target.closest('[data-dec]')) {
        if (qty[id] > 0) qty[id] -= 1;
        show(idx); update(); return;
      }
      if (e.target.closest('[data-select]')) { show(idx); }
    });

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var items = variants.filter(function (v) { return qty[v.id] > 0; })
          .map(function (v) { return { id: v.id, quantity: qty[v.id] }; });
        if (!items.length) return;
        addBtn.classList.add('is-loading');
        addLabel.textContent = 'Adding...';
        fetchJSON(routes.cartAdd + '.js', { method: 'POST', body: JSON.stringify({ items: items }) })
          .then(function () {
            variants.forEach(function (v) { qty[v.id] = 0; });
            update();
            return refreshCart(true);
          })
          .catch(function (err) {
            toast((err && err.description) || 'Could not add to cart. Please try again.');
            update();
          })
          .finally(function () { addBtn.classList.remove('is-loading'); });
      });
    }

    show(current);
    update();
  }

  function initAll() {
    document.querySelectorAll('[data-shop]').forEach(initShop);
  }

  initAll();
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector ? e.target.querySelector('[data-shop]') : null;
    if (el) initShop(el);
  });
})();
